import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _AgreementClassification } from "../../../../core/services/dataBean/EntityCatalogVdos";






export const AgreementClassification = () => {

    const agreement = useDataBean(_AgreementClassification);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [])


    const getLista = () => {

        agreement.instance.getAgreementClassificationCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        agreement.setBean({
            State: 1,
            Since: single.getCurrenDate()
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        agreement.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        agreement.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDAgreementClassification', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Clasificación de Convenio">
            <div className="row">

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={agreement.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">


                                <div className="col-md-12">
                                    <label>Nombre</label>
                                    <textarea name="Name" className="form-control" value={agreement.bean.Name} onChange={agreement.handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={agreement.bean.Description} onChange={agreement.handleChange} />
                                </div>

                            </div>

                        </>
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}